import { closeTransaction, commitEngine, currentTransaction, openTransaction } from "./engine";
import { Node } from "./node";
import { isValueSet, proxify } from "./observable";
class _Node extends Node {
}
class CallableNode extends Function {
    constructor(initValue) {
        super();
        this._memoValue = initValue;
        this._value = new _Node();
        //this._events = new EventNode()
    }
    get $subscriptions() {
        return this._value.$subscriptions;
    }
    $subscribe(subscriber) {
        return this._value.$subscribe(subscriber);
    }
    $unsubscribe(subscription) {
        this._value.$unsubscribe(subscription);
    }
    $touch(subscriber) {
        //throw new Error("Method not implemented.")
    }
    $untouch() {
        //throw new Error("Method not implemented.")
    }
    $publish(next, prev, keys) {
        this._value.$publish(next, prev, keys);
    }
    $call(thisArg, args) {
        // if (this._dirty) {
        //     return
        // }
        const t = openTransaction();
        const sess = currentTransaction();
        sess.called.push({ func: this._memoValue || (() => { }), call: () => {
                if (this._memoValue == null) {
                    // TODO
                    //console.warn('Possible uninitialized callable', args)
                }
                let result = this._memoValue != null ? this._memoValue.apply(thisArg, args) : args[0];
                if (isValueSet(result)) {
                    result = result.$value;
                }
                if (result && result.then) {
                    this.$emit('wait');
                    result = result.then((response) => {
                        this.$emit('done', response);
                        //                this._value.$value = response
                        //                this.$publish(response)
                        return response;
                    }, (fail) => {
                        this.$emit('fail', fail);
                        return fail;
                    });
                }
                else {
                    this.$emit('done', result);
                    //            this._value.$value = result
                    //            this.$publish(result)
                }
                return result;
            } });
        closeTransaction(t);
        // // this._t = null
        if (!t.joined) {
            commitEngine().commit();
        }
        // return result
    }
    $emit(name, ...args) {
        this._value.$emit.apply(this._value, [name, ...args]);
    }
    $on(name, callback, target) {
        return this._value.$on(name, callback, target);
    }
    $off(callbackOrTargetOrListener) {
        this._value.$off(callbackOrTargetOrListener);
    }
    $event(name) {
        return null;
        //throw new Error("Method not implemented.")
    }
    $hasEvent(name) {
        return false;
        //throw new Error("Method not implemented.")
    }
    set $value(value) {
        this._memoValue = value;
    }
    get $value() {
        return this._memoValue;
    }
    get $uid() {
        return '';
    }
    get $isTerminal() {
        return true;
    }
    // FIXME убрать после проверки наличия событий в Hub
    $has() {
        return false;
    }
    $at() {
        return null;
    }
}
export const callable = (initValue) => {
    //const value = isValueSet(initValue) ? initValue.$value : initValue
    return proxify(initValue, new CallableNode(initValue));
};
export const isCallable = (v) => {
    return v && typeof v.$call === 'function';
};
